import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-7 px-4 bg-brand-cream" data-id="element-95">
      <div className="max-w-3xl mx-auto" data-id="element-96">
        <div className="brunson-card rounded-xl p-5 md:p-6 text-center" data-id="element-97">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-green rounded-full border-4 border-brand-navy mb-3" data-id="element-98">
            <ShieldCheck className="w-8 h-8 text-white" data-id="element-99" />
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-navy uppercase leading-tight mb-2" data-id="element-100">
            🛡️ Garantía 7 Días — Sin Vueltas
          </h2>
          <p className="text-sm md:text-base text-brand-ink font-medium leading-snug" data-id="element-101">
            Si en 7 días no sentís que recuperaste tus fines de semana y que tus
            clases mejoraron, contactanos y te devolvemos el{' '}
            <span className="font-bold text-brand-green" data-id="element-102">
              100% de tu dinero
            </span>
            . Garantía total.
          </p>
        </div>
      </div>
    </section>;
}